<template>
	<el-dialog 
        v-if="dialogVisible"
		:visible.sync="dialogVisible" 
		:fullscreen="true"
		:title="fileName"
		append-to-body
		v-loading="isloading"
		>
		<iframe 
			:src="pageUrl" 
			frameborder="0"
			>
		</iframe>
	</el-dialog>
</template>

<script>

export default {
	created() {
	},
	data() {
		return {
			isloading: true,
			dialogVisible: false,
			pageUrl: '',
            fileUrl: '',
            fileName: ''
		}
	},
	mounted() {
	},
	methods: {
        showPage() {
            this.isloading = true
            this.dialogVisible = true
        },

		base64Encode(text) {
			// 先将字符串转换为 UTF-8 编码的 ArrayBuffer
			const encoder = new TextEncoder();
			const encoded = encoder.encode(text);

			// 将 ArrayBuffer 转换为 Uint8Array，然后使用 btoa() 进行 Base64 编码
			return btoa(String.fromCharCode.apply(null, new Uint8Array(encoded)));
		},

		// 生成报告
		show(fileName, fileUrl) {
			// this.fileName = fileName
            // this.isloading = false
            this.pageUrl = 'https://fileview.zhbykj.com/onlinePreview?url='+encodeURIComponent(this.base64Encode('https://www.yunzikongjian.com' + fileUrl))
            // this.dialogVisible = true
			window.open(this.pageUrl)
		},
	}
}
</script>
<style scoped lang="scss">
	.result {
		padding-top: 80px;
		text-align: center;
		min-height: calc(100vh - 370px);
	}
	iframe {
		width: 100%;
		height: calc(100vh - 58px);
	}
	.downloadBtn {
		position: fixed;
		top: 16px;
		right: 50px;
	}
	::v-deep .el-dialog__body {
		padding: 0!important;
	}
</style>
